module.exports = __webpack_public_path__ + "static/media/heroIllustration2x.92098ad8.png";